import type {ISearchComboboxIconProps} from "../types/ISearchComboboxIconProps";
import {SearchComboboxSvgIcon} from "./SearchComboboxSvgIcon";

/** Chevron glyph, 16px. */
export const SearchComboboxChevronRightIcon = (props: ISearchComboboxIconProps) => (
    <SearchComboboxSvgIcon frameSize={16} {...props}>
        <path d="M6 12L10 8L6 4" stroke="currentColor" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
    </SearchComboboxSvgIcon>
);
import type {ISearchComboboxIconProps} from "../types/ISearchComboboxIconProps";
import {SearchComboboxSvgIcon} from "./SearchComboboxSvgIcon";

/** Chevron glyph, 16px. */
export const SearchComboboxChevronRightIcon = (props: ISearchComboboxIconProps) => (
    <SearchComboboxSvgIcon frameSize={16} {...props}>
        <path d="M6 12L10 8L6 4" stroke="currentColor" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
    </SearchComboboxSvgIcon>
);
